import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MaterialModule } from './material.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatToolbarModule } from '@angular/material/toolbar'; // Importa MatToolbarModule
import { MatButtonModule } from '@angular/material/button';   // Importa MatButtonModule
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { SpotifyEmbedComponent } from './components/spotify-embed/spotify-embed.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
/* import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; */
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SafeUrlPipe } from './pipes/safe-url.pipe';

@NgModule({
  declarations: [SpotifyEmbedComponent ,SafeUrlPipe],
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    MatToolbarModule,
    FontAwesomeModule,
    MatButtonModule,
    MatMenuModule,
    ReactiveFormsModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatDividerModule,
    MatSnackBarModule
  ],
  exports: [SpotifyEmbedComponent, SafeUrlPipe],
})
export class SharedModule {}
